import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import Sprite = Phaser.GameObjects.Sprite;

export default class Arrow extends Sprite{

    constructor(scene: Scene) {
        super(scene, 0, 0, Keys.ATLAS_UI, Keys.IMG_ARROW);
    }

    public calculateDisplayHeight(startX: number, startY: number, endX: number, endY: number, offset: number) {
        this.displayHeight = Phaser.Math.Distance.Between(startX, startY, endX, endY) * offset;
    }

    public calculateRotationAngle(startX: number, startY: number, endX: number, endY: number) {
        this.rotation = Phaser.Math.Angle.Between(startX, startY, endX, endY) + Math.PI / 2;
    }

    public setZeroHeight() {
        this.displayHeight = 0;
    }

    public setDisplayHeight(height: number) {
        this.displayHeight = height;
    }



}
